<template>
    <div class="flex flex-col w-full items-center">
        <Combobox
            as="div"
            class="w-full"
            :modelValue="selected"
            v-model="selectedItem"
            @update:modelValue="handleSelection"
        >
            <ComboboxLabel
                class="block text-sm text-[18px] font-semibold text-black pb-[10px]"
                >Columns
            </ComboboxLabel>
            <div class="relative mt-1">
                <ComboboxInput
                    class="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                    @change="query = $event.target.value"
                    :displayValue="(item) => item.name"
                />
                <ComboboxButton
                    class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
                >
                    <SelectorIcon
                        class="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                    />
                </ComboboxButton>

                <ComboboxOptions
                    v-if="filteredItem.length > 0"
                    class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                >
                    <ComboboxOption
                        v-for="item in filteredItem"
                        :key="item.id"
                        :value="item"
                        as="template"
                        v-slot="{ active, selected }"
                    >
                        <li
                            :class="[
                                'relative cursor-default select-none py-2 pl-3 pr-9',
                                active
                                    ? 'bg-indigo-600 text-white'
                                    : 'text-gray-900',
                            ]"
                        >
                            <span
                                :class="[
                                    'block truncate',
                                    selected && 'font-semibold',
                                ]"
                            >
                                {{ item.name }}
                            </span>

                            <span
                                v-if="selected"
                                :class="[
                                    'absolute inset-y-0 right-0 flex items-center pr-4',
                                    active ? 'text-white' : 'text-indigo-600',
                                ]"
                            >
                                <CheckIcon class="h-5 w-5" aria-hidden="true" />
                            </span>
                        </li>
                    </ComboboxOption>
                </ComboboxOptions>
            </div>
        </Combobox>
        <!-- Selected Fields -->
        <div class="flex flex-row space-x-4 flex-wrap mt-[20px]">
            <template v-for="selection in selectedFields">
                <Badge
                    :name="selection.name"
                    @remove="removeSelection(selection)"
                />
            </template>
        </div>
        <button
            @click="applySelection"
            class="w-2/3 mt-[20px] bg-face-red shadow-md rounded-lg shadow-face-red/50 text-white px-4 py-[4px]"
        >
            Apply
        </button>
    </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxLabel,
    ComboboxOption,
    ComboboxOptions,
} from "@headlessui/vue";
import { CheckIcon, SelectorIcon } from "@heroicons/vue/solid";
import Badge from "@/Shared/Badge";

const items = ref([]);
const query = ref("");
const selectedItem = ref({});
const filteredItem = computed(() =>
    query.value === ""
        ? items.value
        : items.value.filter((item) => {
              return item.name
                  .toLowerCase()
                  .includes(query.value.toLowerCase());
          })
);

const emit = defineEmits(["apply"]);
const props = defineProps(["formFields"]);
const fields = ref([]);
const selected = ref({});
const selectedFields = ref([]);

const isSelected = (item) => {
    return selectedFields.value.find((element) => element.id === item.id);
};

onMounted(async () => {
    const { data } = await axios.get("/reports/fields");
    items.value = data;
    selectedFields.value = props.formFields;
    selected.value = {
        id: 1,
        name: "",
        value: "default",
        selected: false,
    };
});

const handleSelection = (obj) => {
    //selected.value = obj;
    selectedFields.value = [...selectedFields.value, obj].reduce((unique, item) => {
        return unique.includes(item) ? unique : [...unique, item];
    }, []);
};

const applySelection = () => {
    emit("apply", selectedFields.value);
};

const removeSelection = (item) => {
    selectedFields.value = selectedFields.value.filter(
        (element) => element.id !== item.id
    );
};
</script>
